import { render, staticRenderFns } from "./PropertiesBar.vue?vue&type=template&id=126aafd7&scoped=true"
import script from "./PropertiesBar.vue?vue&type=script&lang=js"
export * from "./PropertiesBar.vue?vue&type=script&lang=js"
import style0 from "./PropertiesBar.vue?vue&type=style&index=0&id=126aafd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126aafd7",
  null
  
)

export default component.exports